import {
    IconBasic,
    IconBasic1, IconBasic2,
    IconPremium, IconPremium1, IconPremium2, PcInstallService1, PcInstallService2,
    WrapColumn,
    WrapIcon,
    WrapRow,
    WrapSpan,
    WrapText
} from "../../../icomoon";
import React from "react";

export default function LayerContents({itemNumber}) {


    return(
        <>
            {/*기본 조립 일 경우 */}
            {itemNumber === '76709' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <IconBasic/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>기본 선정리</strong>+<strong>공랭 쿨러 추가 장착</strong>+<strong>부팅 테스트 및 바이오스 세팅</strong>을 제공해 드립니다.
                                <br/>조립 후 남은 각 부품의 <strong>정품 박스</strong>는 따로 한 박스로 포장하여 발송해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            {/*<IconBox/>*/}
                            <i className={`talk-caseCooler`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>케이스 쿨러</strong> 구매 시, 고객님의 요청사항에 맞춰 <strong>교체 및 추가 장착</strong>해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }
            {itemNumber === '11275005' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <IconPremium/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>서버 조립</strong>+<strong>프리미엄 선정리</strong>+<strong>공랭/수랭 쿨러 추가 장착</strong>+<strong>부팅 테스트 및 바이오스 세팅</strong>을 제공해 드립니다.
                                <br/>조립 후 남은 각 부품의 <strong>정품 박스</strong>는 따로 한 박스로 포장하여 발송해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            {/*<IconBox/>*/}
                            <i className={`talk-caseCooler`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>케이스 쿨러</strong> 구매 시, 고객님의 요청사항에 맞춰 <strong>교체 및 추가 장착</strong>해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }

            {itemNumber === '1154496' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <IconBasic1/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>기본 선정리</strong>+<strong>공랭 쿨러 추가 장착</strong>+<strong>부팅 테스트 및 바이오스 세팅</strong>+<strong>1년 전국 출장 A/S</strong> 서비스를 제공해 드립니다.
                                <br/>조립 후 남은 각 부품의 <strong>정품 박스</strong>는 따로 한 박스로 포장하여 발송해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            {/*<IconBox/>*/}
                            <i className={`talk-caseCooler`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>케이스 쿨러</strong> 구매 시, 고객님의 요청사항에 맞춰 <strong>교체 및 추가 장착</strong>해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }


            {/*기본 조립 + 2일 경우, 10995920*/}
            {itemNumber === '10995920' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <IconBasic2/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>기본 선정리</strong>+<strong>공랭 쿨러 추가 장착</strong>+<strong>부팅 테스트 및 바이오스 세팅</strong>+<strong>2년 전국 출장 A/S</strong> 서비스를 제공해 드립니다.
                                <br/>조립 후 남은 각 부품의 <strong>정품 박스</strong>는 따로 한 박스로 포장하여 발송해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            {/*<IconBox/>*/}
                            <i className={`talk-caseCooler`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>케이스 쿨러</strong> 구매 시, 고객님의 요청사항에 맞춰 <strong>교체 및 추가 장착</strong>해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }

            {/*프리미엄 + 1일 경우, 11275006*/}
            {itemNumber === '11275006' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <IconPremium1/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>서버 조립</strong>+<strong>프리미엄 선정리</strong>+<strong>공랭/수랭 쿨러 추가 장착</strong>+<strong>부팅 테스트 및 바이오스 세팅</strong>+<strong>1년 전국 출장 A/S</strong> <br/>서비스를 제공해 드립니다.
                                <br/>조립 후 남은 각 부품의 <strong>정품 박스</strong>는 따로 한 박스로 포장하여 발송해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            {/*<IconBox/>*/}
                            <i className={`talk-caseCooler`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>케이스 쿨러</strong> 구매 시, 고객님의 요청사항에 맞춰 <strong>교체 및 추가 장착</strong>해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }

            {/*프리미엄 + 2일 경우, 11275007*/}
            {itemNumber === '11275007' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <IconPremium2/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>서버 조립</strong>+<strong>프리미엄 선정리</strong>+<strong>공랭/수랭 쿨러 추가 장착</strong>+<strong>부팅 테스트 및 바이오스 세팅</strong>+<strong>2년 전국 출장 A/S</strong> <br/>서비스를 제공해 드립니다.
                                <br/>조립 후 남은 각 부품의 <strong>정품 박스</strong>는 따로 한 박스로 포장하여 발송해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            {/*<IconBox/>*/}
                            <i className={`talk-caseCooler`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                <strong>케이스 쿨러</strong> 구매 시, 고객님의 요청사항에 맞춰 <strong>교체 및 추가 장착</strong>해 드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }

            {/*운영체제 설치 서비스*/}
            {itemNumber === '1099814' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <i className={`pc_icons_os_service_icon`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                행복쇼핑은 고객님께 <strong>가장 안정적인 조립PC를 제공</strong>해 드리기 위해 <strong>운영체제 설치서비스를
                                적극 추천</strong>드립니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            <i className={`pc_icons_setting_service_icon`} style={{fontSize: '30px'}}/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                정품 운영체제 설치를 위해 <strong>조립 서비스 신청</strong>과 <strong>정품 운영체제 구매</strong>가 필수입니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }

            {/*출장 PC 설치 서비스*/}
            {itemNumber === '11653042' &&
                <WrapColumn>
                    <WrapRow>
                        <WrapIcon>
                            <PcInstallService2/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                전문 기사가 <strong>직접 방문</strong>하며 PC <strong>설치를 도와드리는 서비스</strong>입니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>

                    <WrapRow>
                        <WrapIcon>
                            <PcInstallService1/>
                        </WrapIcon>
                        <WrapText>
                            <WrapSpan>
                                현장에서 설치할 때 발생할 수 있는 <strong>불량에 대비</strong>하기 위해 <strong>조립 + 전국 출장 A/S 서비스 신청이 필수</strong>입니다.
                            </WrapSpan>
                        </WrapText>
                    </WrapRow>
                </WrapColumn>
            }
        </>
    )
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceAsseblyLayer/layerContents/layerContents.js